<template>
  <div id="smartLockerManagement">
    <div class="main">
      <div
        v-if="isContractAlertBannerShow"
        class="contract-expire-alert"
      >
        <span class="contract-expire-alert__icon"><img src="@/assets/img/intercom/caution.svg" alt="caution" /></span>
        <span class="contract-expire-alert__message">
          <template v-if="lockerContract.status === LockerContractStatus.Expiring">
            {{ $t('SmartLocker.ContractAlertMessage.expiring', { date: displayExpireDate }) }}
          </template>
          <template v-else>
            {{ $t('SmartLocker.ContractAlertMessage.expired', { date: displayExpireDate }) }}
          </template>
        </span>
      </div>
      <div class="title_bar">
        <div class="left">
          <div class="title">
            {{ $t('SmartLocker.Title') }}
            <span
              class="introduction"
              @click="$toExternaLink('https://www.smartdaily.com.tw/smart-cabinet/')"
            >{{ $t("General.Instructions") }}</span>
          </div>
          <div class="tip">
            {{ $t('SmartLocker.Tip') }}
          </div>
        </div>
        <div class="right">
          <el-button
            icon="icon-setting"
            round
            @click="openSetUpDialog"
          >
            {{ $t('SmartLocker.Setting') }}
          </el-button>
        </div>
      </div>
      <el-tabs id="smartLockerTab" v-model="activeName" :before-leave="checkTab">
        <el-tab-pane name="pendingList">
          <span slot="label">
            {{ $t('SmartLocker.Tab1') }}
            <span v-if="pendingListCount > 0" class="badge">
              {{ pendingListCount }}
            </span>
          </span>
        </el-tab-pane>
        <el-tab-pane name="lockerStatus">
          <span slot="label">{{ $t('SmartLocker.Tab2') }}</span>
        </el-tab-pane>
      </el-tabs>
      <router-view ref="view" @reject="getList"></router-view>
    </div>
    <!-- 群組設定 -->
    <SetUpDialog
      ref="SetUpDialog"
    />
    <ContractExpireDialog />
  </div>
</template>
<script>
import { mapMutations, mapState, mapGetters } from 'vuex'
import SetUpDialog from '../SmartLocker/components/SetUpDialog.vue'
import ContractExpireDialog from '../SmartLocker/components/ContractExpireDialog.vue'
import { apiSmartLocker } from '@/api/SmartLocker.js'
import { LockerContractStatus } from './models'
export default {
  components: {
    SetUpDialog,
    ContractExpireDialog
  },
  data () {
    return {
      LockerContractStatus,
      activeName: 'pendingList',
      pendingListCount: 0,
      canClickButton: true // 防止連點button參數
    }
  },
  computed: {
    ...mapState({
      lockerContract: (state) => state.smartLocker.lockerContract,
      isContractAlertBannerShow: (state) => state.smartLocker.isContractAlertBannerShow
    }),
    ...mapGetters('smartLocker', ['displayExpireDate'])
  },
  created () {
    this.setContractDialogVisible(false)
    this.setContractAlertBannerShow(false)
  },
  mounted () {
    this.activeName = this.$route.name
    this.getList()
    this.$store.dispatch('smartLocker/getContractInfo').then(() => {
      this.checkContractStatus()
    })
  },
  methods: {
    ...mapMutations('smartLocker', [
      'setContractAlertBannerShow',
      'setContractDialogVisible'
    ]),
    checkTab (activeName, oldActiveName) {
      if (activeName !== oldActiveName) {
        this.$router.push({ name: activeName })
      }
    },
    checkContractStatus () {
      if (this.lockerContract.status === LockerContractStatus.Expired) {
        this.setContractDialogVisible(true)
      } else if (this.lockerContract.status === LockerContractStatus.Expiring) {
        this.setContractAlertBannerShow(true)
      }
    },
    async getList () {
      try {
        const res = await apiSmartLocker.GetApplyStorageList({})
        if (res?.data?.Data?.ApplyStorageList) {
          this.pendingListCount = res.data.Data.ApplyStorageList.length
        }
      } catch (e) {
        console.log(e)
      }
    },
    openSetUpDialog () {
      if (this.canClickButton) {
        this.canClickButton = false
        this.$refs.SetUpDialog.openDialog()
        setTimeout(() => {
          this.canClickButton = true
        }, 2000)
      }
    }
  }
}
</script>

<style lang="scss" scoped>
#smartLockerManagement {
  padding: 50px 0 10px;
  height: 100%;
  .main {
    min-width: 1140px;
    max-width: 90%;
    margin: 0 auto;
    padding: 30px;
    color: $mainFontColor;
    background-color: #fff;
    box-shadow: 0 0 5px rgba(0, 0, 0, 0.1);
    border-radius: $pageBorderRadius;
    box-sizing: border-box;
    .contract-expire-alert {
      display: flex;
      align-items: center;
      background-color: $bgWarning;
      padding: 16px;
      border-radius: 8px;
      margin-bottom: 15px;
      &__icon {
        width: 20px;
        height: 20px;
        margin-right: 8px;
      }
      &__message {
        font-size: map-get($fontSize, medium);
        font-weight: 600;
        color: $warnColor;
      }
    }
    .title_bar {
      display: flex;
      justify-content: space-between;
      align-items: center;
      margin: 0 0 20px 0;
      .introduction {
        color: $mainColor;
        font-size: 20px;
        font-weight: initial;
        margin: 0 10px;
        text-decoration: underline;
        cursor: pointer;
        &:before {
          content: '(';
          color: #000;
        }
        &:after {
          content: ')';
          color: #000;
        }
      }
      .questionnaire {
        background-color: $bgDark3;
        padding: 5px 8px;
        span{
          color: $mainColor;
          cursor: pointer;
          margin: 0 10px 0 13px;
        }
      }
      .title {
        font-weight: bold;
        font-size: map-get($fontSize, xx-large);
        margin-bottom: 10px;
        text-align: left;
      }
      .tip {
        font-size: map-get($fontSize, small);
        color: $subFontColor;
      }
    }
  }
}
#smartLockerTab {
  text-align: center;
  .badge {
    display: flex;
    justify-content: center;
    min-width: 20px !important;
    height: 20px;
    padding: 4px;
    margin-left: 3px;
    border-radius: 20px;
    background-color: $orangeFontColor;
    color: white;
  }
  ::v-deep .el-tabs {
    @include basicTabs;
    &__header {
      margin: 0 0 0;
    }
    &__item {
      min-width: 130px;
      height: 42px;
      span {
        width: 100%;
        display: flex;
        align-items: center;
      }
    }
  }
}
</style>
